import { Period } from '@enmon/commons/lib/enmon';

export const DATE_RANGE_PICKER_PREDEFINED_TAB_MESSAGES_TRANSLATED = 'components.form.date_range_picker.tab.predefined';

export enum PredefinedTabSection {
  Last = 'last',
  Predefined = 'predefined',
  Year = 'year',
}

export const PREDEFINED_PERIODS = [
  Period.Last24hours,
  Period.Last7days,
  Period.Last30days,
  Period.Last3months,
  Period.Last12months,
  Period.Last24months,
  Period.Last36months,
  Period.PreviousMonth,
] as const;
